import React from "react";
import { Container } from "react-bootstrap";
import "./Terms_Conditions_Drivers.css";

function Terms_Conditions_Drivers() {
  return (
      <>
        <section className=" Privacy_Policy Terms_Conditions">
          <div className="privacy-section">
            <div className="container">
              <div className="privacy-header">
                <div className="privacy-header-left">
                  <h2 className="privacy-title">TERMS & CONDITIONS</h2>
                </div>
                <div className="privacy-header-line"></div>
              </div>
  
              <h4 className="privacy-subtitle">TERMS AND CONDITIONS FOR DRIVERS</h4>
  
              <p className="privacy-description">
           This document is an electronic record in terms of information technology act, 2000 
           and rules thereunder as applicable & the provisions pertaining to 
           electronic records in various statutes as amended by the information technology act, 2000.
              </p>
            </div>
          </div>
  
          <Container>
            <div className="privacy_item">
              <p className="privacy_description"></p>
            </div>
  
            <div className="privacy_item">
              <h5 className="privacy_head">1.The Relationship & Status</h5>
  
              <p className="privacy_description">
              Lorem ipsum is simply dummy text of the printing and typesetting industry. 
             Lorem ipsum has been the industry's standard dummy text ever since the 1500s, when an 
             unknown printer took a galley of type & scrambled it to make a type specimen book. It 
             has survived not only five centuries, but also the leap into electronic typesetting, 
             remaining essentially unchanged. It was popularised in the 1960s with the release of 
            letraset sheets containing lorem ipsum passages, and more recently with desktop publishing 
             software like Aldus PageMaker including versions of lorem ipsum.
              </p>
              
              <div className="privacy_item">
               <h6 className="terms_description">Independent Contractor Status</h6>
               <p className="privacy_description">
                Explicitly states that the Driver is an independent contractor, 
               not an employee, agent, joint venturer, or partner of the Company.
               The Driver is responsible for their own taxes, insurance, and benefits.
              </p>
              </div>

            <div className="privacy_item">
              <h6 className="terms_description">Non-Exclusivity</h6>
             <p className="privacy_description">
               Confirms the Driver is free to work for other companies & set their own hours, 
               but must comply with the App's standards when logged in.
             </p>
             </div>

              <div className="privacy_item">
             <h5 className="terms_description">Facilitator Role</h5>
           <p className="privacy_description">
             Defines the Company's role as a technology provider & facilitator that connects Drivers 
             with Riders, but does not provide transportation services directly.
           </p>
           </div>
            </div>
  
            <div className="privacy_item">
              <h5 className="terms_description">Agreement to Terms:</h5>
              <p className="privacy_description">
                Explicit statement that by downloading, installing, or using the
                application, the User agrees to be bound by the T&Cs and the
                Privacy Policy.
              </p>
            </div>
  
            <div className="privacy_item">
              <h5 className="terms_description">Company's Role</h5>
              <p className="privacy_description">
                Defines the Company as a technology platform that connects Users
                with Independent Third-Party Transportation Providers (Drivers).
                The Company does not provide transportation services itself.
              </p>
            </div>
  
            <div className="privacy_item">
              <h5 className="terms_description">Eligibility:</h5>
              <p className="privacy_description">
                Requires the User to be of legal age (e.g., 18 years old) to enter
                into a binding contract or to use the services under the
                supervision of a parent/guardian.
              </p>
            </div>
  
            <div className="privacy_item">
              <h5 className="terms_description">Amendments:</h5>
              <p className="privacy_description">
                Reserves the Company's right to modify the T&Cs at any time, with
                continued use constituting acceptance of the updated terms.
              </p>
            </div>
  
            <div className="privacy_item">
              <h5 className="privacy_head">2. Driver & Vehicle Requirements</h5>
              <h6 className="terms_description">Driver Eligibility</h6>
              <p className="privacy_description">
              Requirements regarding minimum age, valid driver's license 
            (commercial/PSV, if applicable), clean driving record, and 
              successful background checks.
              </p>
  
              <h6 className="terms_description">Vehicle Eligibility</h6>
              <p className="privacy_description">
                Requirements for the vehicle, including age, model, regular maintenance, 
             valid registration, fitness certificate, & compliance with all local transport laws.
              </p>
  
              <h6 className="terms_description">Documentation</h6>
              <p className="privacy_description">
                Obligation to provide and maintain all necessary legal documents 
             (licenses, permits, insurance, etc.) and promptly upload updates to the App.
                
              </p>

               <div className="privacy_item">
              <h5 className="privacy_head">
                3.Service Standards & Conduct
              </h5>
              <h6 className="terms_description">Professional Conduct</h6>
              <p className="privacy_description">
                Requires courteous, safe, and professional behavior towards Riders and adherence 
             to a strict code of conduct (e.g., proper attire, no soliciting Riders for private rides).
              </p>
  
              <h6 className="terms_description">Safety and Zero Tolerance</h6>
              <p className="privacy_description">
                Strict policy against drugs/alcohol, reckless driving, discrimination, and violence.
             Includes clauses on reporting accidents & immediate suspension procedures.
              </p>
  
              <h6 className="terms_description">Trip Acceptance</h6>
              <p className="privacy_description">
                 Guidelines on accepting and completing rides, minimizing cancellations, 
             and transporting Riders directly to their destination without unauthorized stops.
              </p>
  
              <h6 className="terms_description">Use of Driver App</h6>
              <p className="privacy_description">
                 Rules for using the proprietary application, including maintaining account
             confidentiality & using the app only for authorized purposes.
              </p>
              </div>

              <div className="privacy_item">
              <h5 className="privacy_head">4.  Financial Terms</h5>
              <h6 className="terms_description">Fare Calculation</h6>
              <p className="privacy_description">
               Details how the fare is calculated (time, distance, surge pricing, tolls) and 
             the Company's sole right to set or adjust fares.
              </p>
  
              <h6 className="terms_description">Company Commission</h6>
              <p className="privacy_description">
                Requirements for the vehicle, including age, model, regular maintenance, 
             valid registration, fitness certificate, & compliance with all local transport laws.
              </p>
  
              <h6 className="terms_description">Payments to Driver</h6>
              <p className="privacy_description">
           Terms for remittance of the Driver's share of the Fare 
            (e.g., weekly payments, minimum payout thresholds).
                
              </p>

              <h6 className="terms_description">Cancellations & Refunds</h6>
              <p className="privacy_description">
            Policies regarding driver and rider cancellation fees and how these are managed/paid out.
                
              </p>
              </div>

               <div className="privacy_item">
              <h5 className="privacy_head">
                5.Platform Use & Intellectual Property
              </h5>
              <h6 className="terms_description">Intellectual Property</h6>
              <p className="privacy_description">
                Company retains all rights to the App, logos, software, and technology. The Driver is granted a limited, 
            non-exclusive license to use the App solely for providing services.
              </p>
  
              <h6 className="terms_description">Confidentiality & Data</h6>
              <p className="privacy_description">
                Driver agrees not to misuse or disclose any Rider or Company data (e.g., contact information, trip history, 
             business model details).
              </p>
              </div>

                <div className="privacy_item">
              <h5 className="privacy_head">
               6.Liability and Indemnity
              </h5>
              <h6 className="terms_description">Indemnification</h6>
              <p className="privacy_description">
                Driver agrees to protect and hold the Company harmless from any claims, damages, 
             or liabilities arising from the Driver's actions, negligence, or breach of the agreement.
              </p>
  
              <h6 className="terms_description">Limitation of Liability</h6>
              <p className="privacy_description">
              Company explicitly disclaims liability for certain losses (e.g., lost profits, property damage, or acts/omissions of the Rider).
              </p>
              </div>


               <div className="privacy_item">
              <h5 className="privacy_head">
                7.Termination & Dispute Resolution
              </h5>
              <h6 className="terms_description">Termination</h6>
              <p className="privacy_description">
               Outlines the conditions under which either party can terminate the agreement 
             (e.g., immediate termination for breach, or termination with notice).
              </p>
  
              <h6 className="terms_description">Dispute Resolution</h6>
              <p className="privacy_description">
              Process for handling disputes, including arbitration, mediation, or applicable jurisdiction.
              </p>
              </div>

              
  
  
              
            </div>
          </Container>
        </section>
      </>
    );
  
}

export default Terms_Conditions_Drivers;
